/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lifeScenario/credit_score': {
    width: 20,
    height: 13,
    viewBox: '0 0 20 13',
    data: '<path pid="0" d="M19.75 2.16l-7.686 9.75a1.467 1.467 0 01-2.193.13A1.47 1.47 0 0110 9.847c.2-.16 9.682-7.632 9.75-7.686zM.016 9.386C1.272.932 11.405-2.985 18.019 2.618l-2.306 1.817a8.114 8.114 0 00-4.81-1.572c-4.085 0-7.478 3.018-8.066 6.942a1.426 1.426 0 01-2.821-.42z" _fill="#2CB6F8" fill-rule="evenodd"/>'
  }
})
